<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 - Mesa (13:00 - 20:00)<i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 - Mesa
            <small>{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>
          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body px-3 px-md-9 py-4 py-md-8" v-show="expandirContenido">
        <div class="alert alert-light p-6">
          <h4 class="mb-3 font-weight-bold">Registro de Asistencia</h4>
          <form class="form" id="frm-mesa-turno-2-asistencia" @submit.prevent>
          <div class="row">
            <div class="form-group col-12 col-md-3">
              <label class="mb-1">Nombre del Observador</label>
              <input type="text" class="form-control" v-model="actual.t2ObservadorNombre" placeholder="Nombres y apellidos" autocomplete="off" required />
            </div>
            <div class="form-group col-12 col-md-3">
              <label class="mb-1">DNI</label>
              <input type="text" class="form-control" v-model="actual.t2ObservadorDni" placeholder="Número de documento de identidad" autocomplete="off" required />
            </div>
            <div class="form-group col-12 col-md-3">
              <label class="mb-1">Local de Votación</label>
              <input type="text" class="form-control" :value="localNombre" disabled />
            </div>
            <div class="form-group col-12 col-md-3">
              <label class="mb-1">Nro. de Mesa</label>
              <input type="text" class="form-control" v-model="actual.t2NumeroMesaIngresado" placeholder="Número de mesa..." autocomplete="off" required />
              <small v-if="actual.t2NumeroMesaIngresado && !numeroMesaConfirmado" class="text-danger">El número ingresado no coincide con el de la mesa asignada.</small>
            </div>
            <div class="form-group col-12">
              <label class="mb-1 font-weight-bold">Registro de asistencia</label>
              <div class="btn-group d-flex flex-wrap" role="group">
                <!-- <button type="button" @click.prevent="seleccionarTipoRegistroAsistencia(1)" class="btn flex-fill" :class="[actual.t2TipoRegistroAsistencia === 1 ? 'btn-primary' : 'btn-outline-secondary']"><i class="fa fa-door-open mr-2"></i>Ingresé al local de votación</button> -->
                <button type="button" @click.prevent="seleccionarTipoRegistroAsistencia(2)" class="btn flex-fill" :class="[actual.t2TipoRegistroAsistencia === 2 ? 'btn-success' : 'btn-outline-secondary']"><i class="fa fa-check mr-2"></i>Llegué a la mesa asignada</button>
                <button type="button" @click.prevent="seleccionarTipoRegistroAsistencia(3)" class="btn flex-fill" :class="[actual.t2TipoRegistroAsistencia === 3 ? 'btn-danger' : 'btn-outline-secondary']"><i class="fa fa-ban mr-2"></i>No se permitió el ingreso para la observación electoral</button>
              </div>
              <div v-if="actual.t2TipoRegistroAsistencia === 1" class="alert alert-custom alert-light-info mt-3 mb-0 py-2">
                <i class="fa fa-info-circle mr-1"></i> Has registrado que ingresaste al local pero no llegaste a la mesa. No es necesario completar el cuestionario.
              </div>
              <div v-if="actual.t2TipoRegistroAsistencia === 3" class="alert alert-custom alert-light-warning mt-3 mb-0 py-2">
                <i class="fa fa-info-circle mr-1"></i> Has registrado que no se permitió el ingreso. No es necesario completar el cuestionario.
              </div>
            </div>
          </div>
          </form>
        </div>
        <form v-show="registroAsistenciaCompleto" class="form" id="frm-mesa-turno-2">
          <div class="row">
            <div class="col-xl-2 d-none d-xl-block"></div>
            <div class="col-12 col-xl-8">

              <!-- BLOQUE 2: Instalación de Mesa -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">II. Instalación de Mesa</h3> -->

                <div :class="sheetRowQClass(true, sheetP1Completa)">
                  <label :class="ui.colLeftClass">1. ¿Ya se instaló la mesa de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="setMesaInstalada(true)" class="btn" :class="[actual.t2MesaInstalada === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="setMesaInstalada(false)" class="btn" :class="[actual.t2MesaInstalada === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>

                    <!-- Mesa no instalada -->
                    <div v-if="actual.t2MesaInstalada === false" class="mt-3">
                      <label class="mb-1">Motivo(s) de no instalación:</label>
                      <b-form-checkbox size="lg" v-model="actual.t2NoInstalAusenciaMiembrosMesa" class="mb-2" @change="ui.mostrarErrorMotivoNoInstalacion = false">Ausencia de miembros de mesa</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t2NoInstalFaltaMaterialElectoral" class="mb-2" @change="ui.mostrarErrorMotivoNoInstalacion = false">Falta de material electoral</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t2NoInstalDesastresNaturales" class="mb-2" @change="ui.mostrarErrorMotivoNoInstalacion = false">Desastres naturales</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t2NoInstalOtros" class="mb-2" @change="ui.mostrarErrorMotivoNoInstalacion = false">Otros</b-form-checkbox>
                      <small v-if="ui.mostrarErrorMotivoNoInstalacion && !motivoNoInstalacionSeleccionado" class="text-danger d-block mb-2">Seleccione al menos un motivo de no instalacion.</small>
                      <div v-if="actual.t2NoInstalOtros">
                        <textarea v-model="actual.t2NoInstalOtrosDetalle" class="form-control mt-2" placeholder="Describa el motivo..." required></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BLOQUE 3: Sufragio -->
              <div v-if="actual.t2MesaInstalada === true" class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">III. Sufragio (13:00 - 20:00)</h3> -->

                <div :class="sheetRowQClass(true, sheetP2Completa)">
                  <label :class="ui.colLeftClass">2. ¿Fue fácil identificar el número de mesa de votación asignada?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2FacilIdentificarNumeroMesa = true" class="btn" :class="[actual.t2FacilIdentificarNumeroMesa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2FacilIdentificarNumeroMesa = false" class="btn" :class="[actual.t2FacilIdentificarNumeroMesa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2FacilIdentificarNumeroMesa === false">
                      <textarea v-model="actual.t2FacilIdentificarNumeroMesaDetalle" class="form-control mt-2" placeholder="Señale brevemente el motivo (opcional)..."></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP3Completa)">
                  <label :class="ui.colLeftClass">3. ¿Se brinda atención preferencial a personas con discapacidad, embarazadas y/o adultos mayores en la mesa de votación? Nota: Se refiere a asistencia</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2AtencionPreferencial = true" class="btn" :class="[actual.t2AtencionPreferencial === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2AtencionPreferencial = false" class="btn" :class="[actual.t2AtencionPreferencial === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2AtencionPreferencial === false">
                      <textarea v-model="actual.t2AtencionPreferencialDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle (opcional)..."></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP4Completa)">
                  <label :class="ui.colLeftClass">4. ¿Se ha detectado algún acto de intimidación, coacción, agresión o violencia que impida el ejercicio del voto ciudadano en tu mesa de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2ActoIntimidacionOViolencia = true" class="btn" :class="[actual.t2ActoIntimidacionOViolencia === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2ActoIntimidacionOViolencia = false" class="btn" :class="[actual.t2ActoIntimidacionOViolencia === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2ActoIntimidacionOViolencia === true">
                      <textarea v-model="actual.t2ActoIntimidacionOViolenciaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.t2ActoIntimidacionOViolencia === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP5Completa)">
                  <label :class="ui.colLeftClass">5. ¿Se presento/produjo algún incidente que limita o impide el ejercicio de tus funciones como observador/a electoral?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2IncidenteLimitaLaborObservador = true" class="btn" :class="[actual.t2IncidenteLimitaLaborObservador === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2IncidenteLimitaLaborObservador = false" class="btn" :class="[actual.t2IncidenteLimitaLaborObservador === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2IncidenteLimitaLaborObservador === true">
                      <textarea v-model="actual.t2IncidenteLimitaLaborObservadorDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.t2IncidenteLimitaLaborObservador === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP6Completa)">
                  <label :class="ui.colLeftClass">6. ¿Existe propaganda electoral de alguna organización política en el entorno de tu mesa de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2PropagandaEntornoMesa = true" class="btn" :class="[actual.t2PropagandaEntornoMesa === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="limpiarPropagandaMesa()" class="btn" :class="[actual.t2PropagandaEntornoMesa === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2PropagandaEntornoMesa === true" class="mt-2">
                      <label class="mb-1">Organización política:</label>
                      <div class="btn-group d-flex flex-wrap" role="group">
                        <button v-for="partido in partidosNacionales" :key="partido.parametroId" type="button" @click.prevent="togglePartidoCsv('t2PropagandaEntornoMesaOrganizacionParamIds', partido.parametroId)" class="btn btn-sm" :class="[isPartidoSelected('t2PropagandaEntornoMesaOrganizacionParamIds', partido.parametroId) ? 'btn-primary' : 'btn-outline-secondary']">
                          <img :src="getImagenPartidoPolitico(partido.parametroId)" style="height:20px;width:auto;vertical-align:middle;" class="mr-1" />
                          {{ partido.descripcion }}
                        </button>
                      </div>
                      <small v-if="parsePartidoIds(actual.t2PropagandaEntornoMesaOrganizacionParamIds).length === 0" class="text-danger d-block mt-1">Selecciona al menos una organización política.</small>
                      <textarea v-model="actual.t2PropagandaEntornoMesaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BLOQUE 4: Interrupción del sufragio -->
              <div v-if="actual.t2MesaInstalada === true" class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">IV. Interrupción del Sufragio</h3> -->

                <div :class="sheetRowQClass(true, sheetP7Completa)">
                  <label :class="ui.colLeftClass">7. ¿Hubo alguna interrupción significativa durante el proceso de sufragio? Si la respuesta es Si, indique el motivo.</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="setInterrupcion(true)" class="btn" :class="[actual.t2InterrupcionSufragio === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="setInterrupcion(false)" class="btn" :class="[actual.t2InterrupcionSufragio === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2InterrupcionSufragio === true" class="mt-3">
                      <label class="mb-1">Causas de interrupción:</label>
                      <b-form-checkbox size="lg" v-model="actual.t2InterrupAusenciaMiembroMesa" class="mb-2">Ausencia de miembro de mesa</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t2InterrupTrasladoMesa" class="mb-2">Traslado de mesa</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t2InterrupAltercadoActoresElectorales" class="mb-2">Altercado entre actores electorales</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t2InterrupOtros" class="mb-2">Otros</b-form-checkbox>
                      <div v-if="actual.t2InterrupOtros">
                        <textarea v-model="actual.t2InterrupOtrosDetalle" class="form-control mt-2" placeholder="Describa el motivo..." required></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BLOQUE 5: Escrutinio -->
              <div v-if="actual.t2MesaInstalada === true" class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">V. Desarrollo del Escrutinio</h3> -->

                <div :class="sheetRowQClass(true, sheetP8Completa)">
                  <label :class="ui.colLeftClass">8. ¿Señale la hora de inicio del escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <input type="time" class="form-control" v-model="actual.t2HoraInicioEscrutinio" />
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP9Completa)">
                  <label :class="ui.colLeftClass">9. ¿Hay personeros presentes en la etapa de escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2PersonerosPresentesEnEscrutinio = true" class="btn" :class="[actual.t2PersonerosPresentesEnEscrutinio === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="limpiarPersonerosEscrutinio()" class="btn" :class="[actual.t2PersonerosPresentesEnEscrutinio === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2PersonerosPresentesEnEscrutinio === true" class="mt-2">
                      <label class="mb-1">Organización política:</label>
                      <div class="btn-group d-flex flex-wrap" role="group">
                        <button v-for="partido in partidosNacionales" :key="partido.parametroId" type="button" @click.prevent="togglePartidoCsv('t2PersonerosPresentesEnEscrutinioOrganizacionParamIds', partido.parametroId)" class="btn btn-sm" :class="[isPartidoSelected('t2PersonerosPresentesEnEscrutinioOrganizacionParamIds', partido.parametroId) ? 'btn-primary' : 'btn-outline-secondary']">
                          <img :src="getImagenPartidoPolitico(partido.parametroId)" style="height:20px;width:auto;vertical-align:middle;" class="mr-1" />
                          {{ partido.descripcion }}
                        </button>
                      </div>
                      <small v-if="parsePartidoIds(actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamIds).length === 0" class="text-danger d-block mt-1">Selecciona al menos una organización política.</small>
                      <textarea v-model="actual.t2PersonerosPresentesEnEscrutinioDetalle" class="form-control mt-2" placeholder="Señale qué organizaciones tienen personeros (opcional)..."></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP10Completa)">
                  <label :class="ui.colLeftClass">10. ¿Hubo alguna situación que impidiera la presencia de personeros en la etapa de escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2ImpidioPresenciaPersoneros = true" class="btn" :class="[actual.t2ImpidioPresenciaPersoneros === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2ImpidioPresenciaPersoneros = false" class="btn" :class="[actual.t2ImpidioPresenciaPersoneros === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2ImpidioPresenciaPersoneros === true">
                      <textarea v-model="actual.t2ImpidioPresenciaPersonerosDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP11Completa)">
                  <label :class="ui.colLeftClass">11. ¿El ánfora de votación fue abierta en presencia de todos los asistentes?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2AnforaAbiertaEnPresenciaTodos = true" class="btn" :class="[actual.t2AnforaAbiertaEnPresenciaTodos === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2AnforaAbiertaEnPresenciaTodos = false" class="btn" :class="[actual.t2AnforaAbiertaEnPresenciaTodos === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2AnforaAbiertaEnPresenciaTodos === false">
                      <textarea v-model="actual.t2AnforaAbiertaEnPresenciaTodosDetalle" class="form-control mt-2" placeholder="Detalle del motivo..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP12Completa)">
                  <label :class="ui.colLeftClass">12. ¿El número de cédulas en el ánfora es igual al número de personas que acudieron a votaron según el acta?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2NumeroCedulasIgualVotantes = true" class="btn" :class="[actual.t2NumeroCedulasIgualVotantes === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2NumeroCedulasIgualVotantes = false" class="btn" :class="[actual.t2NumeroCedulasIgualVotantes === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2NumeroCedulasIgualVotantes === false">
                      <textarea v-model="actual.t2NumeroCedulasIgualVotantesDetalle" class="form-control mt-2" placeholder="Detalle del motivo..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP13Completa)">
                  <label :class="ui.colLeftClass">13. ¿Los personeros tuvieron la oportunidad de observar el acta electoral para realizar sus IMPUGNACIONES?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2PersonerosPudieronObservarActa = true" class="btn" :class="[actual.t2PersonerosPudieronObservarActa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2PersonerosPudieronObservarActa = false" class="btn" :class="[actual.t2PersonerosPudieronObservarActa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2PersonerosPudieronObservarActa === false">
                      <textarea v-model="actual.t2PersonerosPudieronObservarActaDetalle" class="form-control mt-2" placeholder="Detalle del motivo (opcional)..."></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP14Completa)">
                  <label :class="ui.colLeftClass">14. ¿Todos los miembros de mesa manifestaron su conformidad con las cifras consignadas en las Actas Electorales?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2MiembrosConformesCifrasActa = true" class="btn" :class="[actual.t2MiembrosConformesCifrasActa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2MiembrosConformesCifrasActa = false" class="btn" :class="[actual.t2MiembrosConformesCifrasActa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2MiembrosConformesCifrasActa === false">
                      <textarea v-model="actual.t2MiembrosConformesCifrasActaDetalle" class="form-control mt-2" placeholder="Detalle del motivo..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP15Completa)">
                  <label :class="ui.colLeftClass">15. ¿Hubo alguna IMPUGNACIÓN de voto en la mesa?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2HuboImpugnacionVoto = true" class="btn" :class="[actual.t2HuboImpugnacionVoto === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2HuboImpugnacionVoto = false" class="btn" :class="[actual.t2HuboImpugnacionVoto === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2HuboImpugnacionVoto === true">
                      <textarea v-model="actual.t2HuboImpugnacionVotoDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP16Completa)">
                  <label :class="ui.colLeftClass">16. ¿Hubo algún pedido de NULIDAD DE MESA por parte de los personeros?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2PedidoNulidadMesa = true" class="btn" :class="[actual.t2PedidoNulidadMesa === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2PedidoNulidadMesa = false" class="btn" :class="[actual.t2PedidoNulidadMesa === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2PedidoNulidadMesa === true">
                      <textarea v-model="actual.t2PedidoNulidadMesaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP17Completa)">
                  <label :class="ui.colLeftClass">17. ¿Se registró algún incidente o altercado entre los presentes durante el escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="setIncidenteEscrutinio(true)" class="btn" :class="[actual.t2IncidenteEscrutinio === true ? 'btn-danger' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="setIncidenteEscrutinio(false)" class="btn" :class="[actual.t2IncidenteEscrutinio === false ? 'btn-success' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2IncidenteEscrutinio === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                    <div v-if="actual.t2IncidenteEscrutinio === true" class="mt-3">
                      <label class="mb-1">Detallar a quienes:</label>
                      <div class="btn-group btn-group flex-wrap" role="group">
                        <button type="button" @click.prevent="actual.t2IncidenteEscrutinioOnpe = !actual.t2IncidenteEscrutinioOnpe" class="btn" :class="[actual.t2IncidenteEscrutinioOnpe ? 'btn-primary' : 'btn-outline-secondary']">ONPE</button>
                        <button type="button" @click.prevent="actual.t2IncidenteEscrutinioJne = !actual.t2IncidenteEscrutinioJne" class="btn" :class="[actual.t2IncidenteEscrutinioJne ? 'btn-primary' : 'btn-outline-secondary']">JNE</button>
                        <button type="button" @click.prevent="actual.t2IncidenteEscrutinioPersoneros = !actual.t2IncidenteEscrutinioPersoneros" class="btn" :class="[actual.t2IncidenteEscrutinioPersoneros ? 'btn-primary' : 'btn-outline-secondary']">Personeros</button>
                        <button type="button" @click.prevent="actual.t2IncidenteEscrutinioPnpFfaa = !actual.t2IncidenteEscrutinioPnpFfaa" class="btn" :class="[actual.t2IncidenteEscrutinioPnpFfaa ? 'btn-primary' : 'btn-outline-secondary']">PNP / FFAA</button>
                        <button type="button" @click.prevent="actual.t2IncidenteEscrutinioMiembrosMesa = !actual.t2IncidenteEscrutinioMiembrosMesa" class="btn" :class="[actual.t2IncidenteEscrutinioMiembrosMesa ? 'btn-primary' : 'btn-outline-secondary']">Miembros de mesa</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <div class="col-xl-2 d-none d-xl-block"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { sheetBoolAnswered, sheetNonEmpty } from "@/helpers/sheetQuestion.js";

export default {
  name: "ficha-mesa-turno-2-2026",
  props: {
    mesaVotacionId: { type: Number },
    localVotacionId: { type: Number },
    procesoElectoralId: { type: Number },
    expandirContenido: { type: Boolean },
    intervaloAutoGuardado: { type: Number },
  },
  data: () => ({
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
    },
    ui: {
      colLeftClass: "col-12 col-md-5 col-form-label",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
      mostrarErrorMotivoNoInstalacion: false,
    },
    temporizadorGuardado: null,
    numeroMesaEsperado: null,
    localNombre: null,
    partidos: [],
    actual: {
      t2ObservadorNombre: null,
      t2ObservadorDni: null,
      t2TipoRegistroAsistencia: null,
      t2NumeroMesaIngresado: null,
      t2MesaInstalada: null,
      t2NoInstalAusenciaMiembrosMesa: null,
      t2NoInstalFaltaMaterialElectoral: null,
      t2NoInstalDesastresNaturales: null,
      t2NoInstalOtros: null,
      t2NoInstalOtrosDetalle: null,
      t2FacilIdentificarNumeroMesa: null,
      t2FacilIdentificarNumeroMesaDetalle: null,
      t2AtencionPreferencial: null,
      t2AtencionPreferencialDetalle: null,
      t2ActoIntimidacionOViolencia: null,
      t2ActoIntimidacionOViolenciaDetalle: null,
      t2IncidenteLimitaLaborObservador: null,
      t2IncidenteLimitaLaborObservadorDetalle: null,
      t2PropagandaEntornoMesa: null,
      t2PropagandaEntornoMesaOrganizacionParamId: null,
      t2PropagandaEntornoMesaOrganizacionParamIds: null,
      t2PropagandaEntornoMesaDetalle: null,
      t2InterrupcionSufragio: null,
      t2InterrupAusenciaMiembroMesa: null,
      t2InterrupTrasladoMesa: null,
      t2InterrupAltercadoActoresElectorales: null,
      t2InterrupOtros: null,
      t2InterrupOtrosDetalle: null,
      t2HoraInicioEscrutinio: null,
      t2PersonerosPresentesEnEscrutinio: null,
      t2PersonerosPresentesEnEscrutinioDetalle: null,
      t2PersonerosPresentesEnEscrutinioOrganizacionParamId: null,
      t2PersonerosPresentesEnEscrutinioOrganizacionParamIds: null,
      t2ImpidioPresenciaPersoneros: null,
      t2ImpidioPresenciaPersonerosDetalle: null,
      t2AnforaAbiertaEnPresenciaTodos: null,
      t2AnforaAbiertaEnPresenciaTodosDetalle: null,
      t2NumeroCedulasIgualVotantes: null,
      t2NumeroCedulasIgualVotantesDetalle: null,
      t2PersonerosPudieronObservarActa: null,
      t2PersonerosPudieronObservarActaDetalle: null,
      t2MiembrosConformesCifrasActa: null,
      t2MiembrosConformesCifrasActaDetalle: null,
      t2HuboImpugnacionVoto: null,
      t2HuboImpugnacionVotoDetalle: null,
      t2PedidoNulidadMesa: null,
      t2PedidoNulidadMesaDetalle: null,
      t2IncidenteEscrutinio: null,
      t2IncidenteEscrutinioOnpe: null,
      t2IncidenteEscrutinioJne: null,
      t2IncidenteEscrutinioPersoneros: null,
      t2IncidenteEscrutinioPnpFfaa: null,
      t2IncidenteEscrutinioMiembrosMesa: null,
    },
    guardado: {
      t2ObservadorNombre: null,
      t2ObservadorDni: null,
      t2TipoRegistroAsistencia: null,
      t2NumeroMesaIngresado: null,
      t2MesaInstalada: null,
      t2NoInstalAusenciaMiembrosMesa: null,
      t2NoInstalFaltaMaterialElectoral: null,
      t2NoInstalDesastresNaturales: null,
      t2NoInstalOtros: null,
      t2NoInstalOtrosDetalle: null,
      t2FacilIdentificarNumeroMesa: null,
      t2FacilIdentificarNumeroMesaDetalle: null,
      t2AtencionPreferencial: null,
      t2AtencionPreferencialDetalle: null,
      t2ActoIntimidacionOViolencia: null,
      t2ActoIntimidacionOViolenciaDetalle: null,
      t2IncidenteLimitaLaborObservador: null,
      t2IncidenteLimitaLaborObservadorDetalle: null,
      t2PropagandaEntornoMesa: null,
      t2PropagandaEntornoMesaOrganizacionParamId: null,
      t2PropagandaEntornoMesaOrganizacionParamIds: null,
      t2PropagandaEntornoMesaDetalle: null,
      t2InterrupcionSufragio: null,
      t2InterrupAusenciaMiembroMesa: null,
      t2InterrupTrasladoMesa: null,
      t2InterrupAltercadoActoresElectorales: null,
      t2InterrupOtros: null,
      t2InterrupOtrosDetalle: null,
      t2HoraInicioEscrutinio: null,
      t2PersonerosPresentesEnEscrutinio: null,
      t2PersonerosPresentesEnEscrutinioDetalle: null,
      t2PersonerosPresentesEnEscrutinioOrganizacionParamId: null,
      t2PersonerosPresentesEnEscrutinioOrganizacionParamIds: null,
      t2ImpidioPresenciaPersoneros: null,
      t2ImpidioPresenciaPersonerosDetalle: null,
      t2AnforaAbiertaEnPresenciaTodos: null,
      t2AnforaAbiertaEnPresenciaTodosDetalle: null,
      t2NumeroCedulasIgualVotantes: null,
      t2NumeroCedulasIgualVotantesDetalle: null,
      t2PersonerosPudieronObservarActa: null,
      t2PersonerosPudieronObservarActaDetalle: null,
      t2MiembrosConformesCifrasActa: null,
      t2MiembrosConformesCifrasActaDetalle: null,
      t2HuboImpugnacionVoto: null,
      t2HuboImpugnacionVotoDetalle: null,
      t2PedidoNulidadMesa: null,
      t2PedidoNulidadMesaDetalle: null,
      t2IncidenteEscrutinio: null,
      t2IncidenteEscrutinioOnpe: null,
      t2IncidenteEscrutinioJne: null,
      t2IncidenteEscrutinioPersoneros: null,
      t2IncidenteEscrutinioPnpFfaa: null,
      t2IncidenteEscrutinioMiembrosMesa: null,
    },
  }),
  computed: {
    partidosNacionales() {
      return (this.partidos || []).filter(p => p.regionId == 0);
    },
    isDirty() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha() {
      return this.ui.tieneCargaInicial && !!this.auth.autorizadoEdicionTurno;
    },
    numeroMesaConfirmado() {
      var ingresado = (this.actual.t2NumeroMesaIngresado || "").toString().trim();
      var esperado = (this.numeroMesaEsperado || "").toString().trim();
      return esperado.length > 0 && ingresado === esperado;
    },
    datosAsistenciaValidos() {
      var nombre = (this.actual.t2ObservadorNombre || "").toString().trim();
      var dni = (this.actual.t2ObservadorDni || "").toString().trim();
      return nombre.length > 0 && dni.length > 0 && this.numeroMesaConfirmado;
    },
    registroAsistenciaCompleto() {
      return this.datosAsistenciaValidos && this.actual.t2TipoRegistroAsistencia === 2;
    },
    sheetMesaBloquesAplica() {
      return this.actual.t2MesaInstalada === true;
    },
    motivoNoInstalacionSeleccionado() {
      return !!(
        this.actual.t2NoInstalAusenciaMiembrosMesa ||
        this.actual.t2NoInstalFaltaMaterialElectoral ||
        this.actual.t2NoInstalDesastresNaturales ||
        this.actual.t2NoInstalOtros
      );
    },
    motivoNoInstalacionValido() {
      if (this.actual.t2MesaInstalada !== false) return true;
      if (!this.motivoNoInstalacionSeleccionado) return false;
      if (this.actual.t2NoInstalOtros && !sheetNonEmpty(this.actual.t2NoInstalOtrosDetalle)) return false;
      return true;
    },
    sheetP1Completa() {
      const m = this.actual.t2MesaInstalada;
      if (!sheetBoolAnswered(m)) return false;
      if (m === true) return true;
      return this.motivoNoInstalacionValido;
    },
    sheetP2Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      return sheetBoolAnswered(this.actual.t2FacilIdentificarNumeroMesa);
    },
    sheetP3Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      return sheetBoolAnswered(this.actual.t2AtencionPreferencial);
    },
    sheetP4Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2ActoIntimidacionOViolencia;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2ActoIntimidacionOViolenciaDetalle);
      return true;
    },
    sheetP5Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2IncidenteLimitaLaborObservador;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2IncidenteLimitaLaborObservadorDetalle);
      return true;
    },
    sheetP6Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2PropagandaEntornoMesa;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        if (this.parsePartidoIds(this.actual.t2PropagandaEntornoMesaOrganizacionParamIds).length === 0) return false;
        return sheetNonEmpty(this.actual.t2PropagandaEntornoMesaDetalle);
      }
      return true;
    },
    sheetP7Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2InterrupcionSufragio;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        const a = this.actual.t2InterrupAusenciaMiembroMesa;
        const b = this.actual.t2InterrupTrasladoMesa;
        const c = this.actual.t2InterrupAltercadoActoresElectorales;
        const d = this.actual.t2InterrupOtros;
        if (!(a || b || c || d)) return false;
        if (d && !sheetNonEmpty(this.actual.t2InterrupOtrosDetalle)) return false;
        return true;
      }
      return true;
    },
    sheetP8Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      return sheetNonEmpty(this.actual.t2HoraInicioEscrutinio);
    },
    sheetP9Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2PersonerosPresentesEnEscrutinio;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        return this.parsePartidoIds(this.actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamIds).length > 0;
      }
      return true;
    },
    sheetP10Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2ImpidioPresenciaPersoneros;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2ImpidioPresenciaPersonerosDetalle);
      return true;
    },
    sheetP11Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2AnforaAbiertaEnPresenciaTodos;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.t2AnforaAbiertaEnPresenciaTodosDetalle);
      return true;
    },
    sheetP12Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2NumeroCedulasIgualVotantes;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.t2NumeroCedulasIgualVotantesDetalle);
      return true;
    },
    sheetP13Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      return sheetBoolAnswered(this.actual.t2PersonerosPudieronObservarActa);
    },
    sheetP14Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2MiembrosConformesCifrasActa;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.t2MiembrosConformesCifrasActaDetalle);
      return true;
    },
    sheetP15Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2HuboImpugnacionVoto;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2HuboImpugnacionVotoDetalle);
      return true;
    },
    sheetP16Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2PedidoNulidadMesa;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.t2PedidoNulidadMesaDetalle);
      return true;
    },
    sheetP17Completa() {
      if (!this.sheetMesaBloquesAplica) return true;
      const x = this.actual.t2IncidenteEscrutinio;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        return !!(
          this.actual.t2IncidenteEscrutinioOnpe ||
          this.actual.t2IncidenteEscrutinioJne ||
          this.actual.t2IncidenteEscrutinioPersoneros ||
          this.actual.t2IncidenteEscrutinioPnpFfaa ||
          this.actual.t2IncidenteEscrutinioMiembrosMesa
        );
      }
      return true;
    },
  },
  methods: {
    sheetRowQClass(aplica, completa) {
      if (!aplica) return ["form-group", "row"];
      return ["form-group", "row", "sheet-question", completa ? "sheet-question--completada" : "sheet-question--pendiente"];
    },
    fetchPartidosPoliticos() {
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } })
        .then(function (response) { this.partidos = response.body.data; });
    },
    getImagenPartidoPolitico(partidoPoliticoParamId) {
      var partido = this.partidos.find(x => x.parametroId == partidoPoliticoParamId);
      var imagen = partido ? partido.imagen : "app-partidos/_no-image.png";
      return `${this.apiResource(imagen)}`;
    },
    toggleOrganizacion(campo, parametroId) {
      this.actual[campo] = this.actual[campo] === parametroId ? null : parametroId;
    },
    parsePartidoIds(csv) {
      if (!csv) return [];
      return csv.toString().split(",").map(s => parseInt(s, 10)).filter(n => !isNaN(n));
    },
    isPartidoSelected(campo, parametroId) {
      return this.parsePartidoIds(this.actual[campo]).indexOf(parametroId) !== -1;
    },
    togglePartidoCsv(campo, parametroId) {
      var ids = this.parsePartidoIds(this.actual[campo]);
      var idx = ids.indexOf(parametroId);
      if (idx === -1) ids.push(parametroId);
      else ids.splice(idx, 1);
      this.actual[campo] = ids.length ? ids.join(",") : null;
    },
    validarRegistroAsistencia() {
      return this.isFormValid("frm-mesa-turno-2-asistencia");
    },
    limpiarPropagandaMesa() {
      this.actual.t2PropagandaEntornoMesa = false;
      this.actual.t2PropagandaEntornoMesaOrganizacionParamId = null;
      this.actual.t2PropagandaEntornoMesaOrganizacionParamIds = null;
      this.actual.t2PropagandaEntornoMesaDetalle = null;
    },
    limpiarPersonerosEscrutinio() {
      this.actual.t2PersonerosPresentesEnEscrutinio = false;
      this.actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamId = null;
      this.actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamIds = null;
      this.actual.t2PersonerosPresentesEnEscrutinioDetalle = null;
    },
    hayDatosTurno2() {
      // detecta si ya hay datos ingresados aparte del campo t2MesaInstalada
      var a = this.actual;
      return (
        a.t2NoInstalAusenciaMiembrosMesa || a.t2NoInstalFaltaMaterialElectoral || a.t2NoInstalDesastresNaturales || a.t2NoInstalOtros || a.t2NoInstalOtrosDetalle ||
        a.t2FacilIdentificarNumeroMesa !== null || a.t2AtencionPreferencial !== null || a.t2ActoIntimidacionOViolencia !== null ||
        a.t2IncidenteLimitaLaborObservador !== null || a.t2PropagandaEntornoMesa !== null || a.t2InterrupcionSufragio !== null ||
        a.t2HoraInicioEscrutinio || a.t2PersonerosPresentesEnEscrutinio !== null || a.t2ImpidioPresenciaPersoneros !== null ||
        a.t2AnforaAbiertaEnPresenciaTodos !== null || a.t2NumeroCedulasIgualVotantes !== null || a.t2PersonerosPudieronObservarActa !== null ||
        a.t2MiembrosConformesCifrasActa !== null || a.t2HuboImpugnacionVoto !== null || a.t2PedidoNulidadMesa !== null || a.t2IncidenteEscrutinio !== null
      );
    },
    hayDatosCuestionarioRA() {
      return this.actual.t2MesaInstalada !== null || this.hayDatosTurno2();
    },
    resetCuestionarioTurno() {
      var a = this.actual;
      a.t2MesaInstalada = null;
      a.t2NoInstalAusenciaMiembrosMesa = null;
      a.t2NoInstalFaltaMaterialElectoral = null;
      a.t2NoInstalDesastresNaturales = null;
      a.t2NoInstalOtros = null;
      a.t2NoInstalOtrosDetalle = null;
      a.t2FacilIdentificarNumeroMesa = null;
      a.t2FacilIdentificarNumeroMesaDetalle = null;
      a.t2AtencionPreferencial = null;
      a.t2AtencionPreferencialDetalle = null;
      a.t2ActoIntimidacionOViolencia = null;
      a.t2ActoIntimidacionOViolenciaDetalle = null;
      a.t2IncidenteLimitaLaborObservador = null;
      a.t2IncidenteLimitaLaborObservadorDetalle = null;
      a.t2PropagandaEntornoMesa = null;
      a.t2PropagandaEntornoMesaOrganizacionParamId = null;
      a.t2PropagandaEntornoMesaOrganizacionParamIds = null;
      a.t2PropagandaEntornoMesaDetalle = null;
      a.t2InterrupcionSufragio = null;
      a.t2InterrupAusenciaMiembroMesa = null;
      a.t2InterrupTrasladoMesa = null;
      a.t2InterrupAltercadoActoresElectorales = null;
      a.t2InterrupOtros = null;
      a.t2InterrupOtrosDetalle = null;
      a.t2HoraInicioEscrutinio = null;
      a.t2PersonerosPresentesEnEscrutinio = null;
      a.t2PersonerosPresentesEnEscrutinioDetalle = null;
      a.t2PersonerosPresentesEnEscrutinioOrganizacionParamId = null;
      a.t2PersonerosPresentesEnEscrutinioOrganizacionParamIds = null;
      a.t2ImpidioPresenciaPersoneros = null;
      a.t2ImpidioPresenciaPersonerosDetalle = null;
      a.t2AnforaAbiertaEnPresenciaTodos = null;
      a.t2AnforaAbiertaEnPresenciaTodosDetalle = null;
      a.t2NumeroCedulasIgualVotantes = null;
      a.t2NumeroCedulasIgualVotantesDetalle = null;
      a.t2PersonerosPudieronObservarActa = null;
      a.t2PersonerosPudieronObservarActaDetalle = null;
      a.t2MiembrosConformesCifrasActa = null;
      a.t2MiembrosConformesCifrasActaDetalle = null;
      a.t2HuboImpugnacionVoto = null;
      a.t2HuboImpugnacionVotoDetalle = null;
      a.t2PedidoNulidadMesa = null;
      a.t2PedidoNulidadMesaDetalle = null;
      a.t2IncidenteEscrutinio = null;
      a.t2IncidenteEscrutinioOnpe = null;
      a.t2IncidenteEscrutinioJne = null;
      a.t2IncidenteEscrutinioPersoneros = null;
      a.t2IncidenteEscrutinioPnpFfaa = null;
      a.t2IncidenteEscrutinioMiembrosMesa = null;
    },
    seleccionarTipoRegistroAsistencia(valor) {
      if (this.actual.t2TipoRegistroAsistencia === valor) return;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        this.$bvToast.toast("Completa el Nombre del Observador, DNI y Nro. de Mesa antes de continuar.", { title: "Registro de Asistencia", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return;
      }
      if (this.hayDatosCuestionarioRA()) {
        var vm = this;
        this.$bvModal.msgBoxConfirm(
          "Se borrarán todos los datos ya registrados en el cuestionario de esta ficha. ¿Deseas continuar?",
          {
            title: "Confirmar cambio",
            okTitle: "Sí, borrar y continuar",
            cancelTitle: "Cancelar",
            okVariant: "danger",
            centered: true,
          }
        ).then(function (confirmado) {
          if (!confirmado) return;
          vm.resetCuestionarioTurno();
          vm.$set(vm.actual, "t2TipoRegistroAsistencia", valor);
        });
        return;
      }
      this.$set(this.actual, "t2TipoRegistroAsistencia", valor);
    },
    setMesaInstalada(valor) {
      // Si ya existe respuesta previa distinta y hay datos cargados, confirmar
      if (this.actual.t2MesaInstalada !== null && this.actual.t2MesaInstalada !== valor && this.hayDatosTurno2()) {
        var vm = this;
        Swal.fire({
          icon: "warning",
          title: "¿Cambiar respuesta?",
          text: "Al cambiar la respuesta se borrarán los datos ya ingresados en este turno. ¿Deseas continuar?",
          showCancelButton: true,
          confirmButtonText: "Sí, cambiar",
          cancelButtonText: "Cancelar",
        }).then(function (result) {
          if (result.value) vm.aplicarMesaInstalada(valor);
        });
        return;
      }
      this.aplicarMesaInstalada(valor);
    },
    aplicarMesaInstalada(valor) {
      this.actual.t2MesaInstalada = valor;
      this.ui.mostrarErrorMotivoNoInstalacion = false;
      if (valor === true) {
        this.actual.t2NoInstalAusenciaMiembrosMesa = null;
        this.actual.t2NoInstalFaltaMaterialElectoral = null;
        this.actual.t2NoInstalDesastresNaturales = null;
        this.actual.t2NoInstalOtros = null;
        this.actual.t2NoInstalOtrosDetalle = null;
      } else if (valor === false) {
        this.actual.t2FacilIdentificarNumeroMesa = null;
        this.actual.t2FacilIdentificarNumeroMesaDetalle = null;
        this.actual.t2AtencionPreferencial = null;
        this.actual.t2AtencionPreferencialDetalle = null;
        this.actual.t2ActoIntimidacionOViolencia = null;
        this.actual.t2ActoIntimidacionOViolenciaDetalle = null;
        this.actual.t2IncidenteLimitaLaborObservador = null;
        this.actual.t2IncidenteLimitaLaborObservadorDetalle = null;
        this.actual.t2PropagandaEntornoMesa = null;
        this.actual.t2PropagandaEntornoMesaOrganizacionParamId = null;
        this.actual.t2PropagandaEntornoMesaOrganizacionParamIds = null;
        this.actual.t2PropagandaEntornoMesaDetalle = null;
        this.actual.t2InterrupcionSufragio = null;
        this.actual.t2InterrupAusenciaMiembroMesa = null;
        this.actual.t2InterrupTrasladoMesa = null;
        this.actual.t2InterrupAltercadoActoresElectorales = null;
        this.actual.t2InterrupOtros = null;
        this.actual.t2InterrupOtrosDetalle = null;
        this.actual.t2HoraInicioEscrutinio = null;
        this.actual.t2PersonerosPresentesEnEscrutinio = null;
        this.actual.t2PersonerosPresentesEnEscrutinioDetalle = null;
        this.actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamId = null;
        this.actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamIds = null;
        this.actual.t2ImpidioPresenciaPersoneros = null;
        this.actual.t2ImpidioPresenciaPersonerosDetalle = null;
        this.actual.t2AnforaAbiertaEnPresenciaTodos = null;
        this.actual.t2AnforaAbiertaEnPresenciaTodosDetalle = null;
        this.actual.t2NumeroCedulasIgualVotantes = null;
        this.actual.t2NumeroCedulasIgualVotantesDetalle = null;
        this.actual.t2PersonerosPudieronObservarActa = null;
        this.actual.t2PersonerosPudieronObservarActaDetalle = null;
        this.actual.t2MiembrosConformesCifrasActa = null;
        this.actual.t2MiembrosConformesCifrasActaDetalle = null;
        this.actual.t2HuboImpugnacionVoto = null;
        this.actual.t2HuboImpugnacionVotoDetalle = null;
        this.actual.t2PedidoNulidadMesa = null;
        this.actual.t2PedidoNulidadMesaDetalle = null;
        this.actual.t2IncidenteEscrutinio = null;
        this.actual.t2IncidenteEscrutinioOnpe = null;
        this.actual.t2IncidenteEscrutinioJne = null;
        this.actual.t2IncidenteEscrutinioPersoneros = null;
        this.actual.t2IncidenteEscrutinioPnpFfaa = null;
        this.actual.t2IncidenteEscrutinioMiembrosMesa = null;
      }
    },
    validarMesaInstalada(omitirNotificacion) {
      this.ui.mostrarErrorMotivoNoInstalacion = this.actual.t2MesaInstalada === false && !this.motivoNoInstalacionSeleccionado;
      if (this.ui.mostrarErrorMotivoNoInstalacion) {
        if (omitirNotificacion != true) this.$bvToast.toast("Seleccione al menos un motivo de no instalacion de mesa.", { title: "Mesa - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      return true;
    },
    setInterrupcion(valor) {
      this.actual.t2InterrupcionSufragio = valor;
      if (valor === false) {
        this.actual.t2InterrupAusenciaMiembroMesa = null;
        this.actual.t2InterrupTrasladoMesa = null;
        this.actual.t2InterrupAltercadoActoresElectorales = null;
        this.actual.t2InterrupOtros = null;
        this.actual.t2InterrupOtrosDetalle = null;
      }
    },
    setIncidenteEscrutinio(valor) {
      this.actual.t2IncidenteEscrutinio = valor;
      if (valor === false) {
        this.actual.t2IncidenteEscrutinioOnpe = null;
        this.actual.t2IncidenteEscrutinioJne = null;
        this.actual.t2IncidenteEscrutinioPersoneros = null;
        this.actual.t2IncidenteEscrutinioPnpFfaa = null;
        this.actual.t2IncidenteEscrutinioMiembrosMesa = null;
      }
    },
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var vActual = JSON.stringify(fichaActual[propiedad]);
      var vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return (vActual == vGuardado && vGuardado != vActualizado) ? fichaActualizada[propiedad] : fichaActual[propiedad];
    },
    inicializarGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos || !this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function () {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) vm.doGuardado(true);
      }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function () {
      this.ui.estaCargandoDatos = true;
      var model = { mesaVotacionId: this.mesaVotacionId, procesoElectoralId: this.procesoElectoralId };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaMesaTurnoDos"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;
          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          Object.keys(tempActual).forEach(c => { tempActual[c] = this.actualizarBaseDiferente(c, tempActual, tempGuardado, ficha); });

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
          this.numeroMesaEsperado = response.body.data.numeroMesaEsperado;
          this.localNombre = response.body.data.localNombre;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    doGuardado: async function (omitirNotificacion) {
      if (this.ui.estaGuardando) return;
      if (omitirNotificacion == true && !this.datosAsistenciaValidos) return false;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        if (omitirNotificacion != true) this.$bvToast.toast("Completa el Nombre del Observador, DNI y Nro. de Mesa antes de guardar.", { title: "Mesa - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      if (!this.validarMesaInstalada(omitirNotificacion)) return false;
      if (this.sheetMesaBloquesAplica) {
        if (this.actual.t2PropagandaEntornoMesa === true && this.parsePartidoIds(this.actual.t2PropagandaEntornoMesaOrganizacionParamIds).length === 0) {
          if (omitirNotificacion != true) this.$bvToast.toast("Selecciona al menos una organización política para la pregunta 6.", { title: "Mesa - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
          return false;
        }
        if (this.actual.t2PersonerosPresentesEnEscrutinio === true && this.parsePartidoIds(this.actual.t2PersonerosPresentesEnEscrutinioOrganizacionParamIds).length === 0) {
          if (omitirNotificacion != true) this.$bvToast.toast("Selecciona al menos una organización política para la pregunta 9.", { title: "Mesa - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
          return false;
        }
      }
      if (!this.isFormValid("frm-mesa-turno-2")) {
        if (omitirNotificacion != true) this.$bvToast.toast("Hay campos con valores incorrectos.", { title: "Mesa - Turno 2", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }

      var actualClone = this.cloneObject(this.actual);
      var model = this.cloneObject(this.actual);
      model.mesaVotacionId = this.mesaVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExitoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaMesaTurnoDos"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;
          if (omitirNotificacion != true) this.$bvToast.toast("Los cambios se han guardado correctamente.", { title: "Mesa - Turno 2", autoHideDelay: 5000, variant: "success", appendToast: false, solid: true });
          guardadoExitoso = true;
          this.doCargarFicha();
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExitoso;
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>

<style scoped>
.card-body .btn-outline-secondary {
  background-color: #fff;
}
</style>
